/**
 * Thrown when a User Management feature is not yet integrated (no API in contract or not wired).
 * These are **expected** until backend + FE ship the integration; callers may choose not to report to Sentry.
 */
export class UserManagementGapError extends Error {
  override readonly name = 'UserManagementGapError';

  constructor(
    message: string,
    readonly code: UserManagementGapCode
  ) {
    super(message);
  }
}

export type UserManagementGapCode =
  | 'snapshotCompare'
  | 'snapshotCompareUsers'
  | 'clearForceNewPassword'
  | 'approvalSummaryShape'
  | 'createUser';

export const USER_MANAGEMENT_GAP_MESSAGE = {
  snapshotCompare: 'Snapshot compare is not integrated: no compare route in the published OpenAPI; implement when the backend adds it.',
  snapshotCompareUsers:
    'Snapshot compare (users with changes) is not integrated: no list route in the published OpenAPI; implement when the backend adds it.',
  clearForceNewPassword: 'Clearing the force-new-password flag is not implemented: no documented API for that action.',
  approvalSummaryShape: 'GET /approval-requests/summary did not return the expected summary object (e.g. pendingReview).',
  createUser:
    'Create user is not integrated: there is no POST /users in the published User Management contract; provision users upstream or add the route.'
} as const;

export function isUserManagementGapError(e: unknown): e is UserManagementGapError {
  return e instanceof UserManagementGapError;
}
